const CardChipButtonTwo = ({ children }) => {
  return (
    <div className="flex flex-col justify-start items-start gap-2 ">
      <div
        className={
          "px-1.5 py-[1px]  gap-1 flex justify-center items-center bg-global-theme custom-card-buttom rounded-md border border-[#D0D5DD] bg-white shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]"
        }
      >
        <div className="text-[#344054] text-xs leading-[18px] font-medium capitalize">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CardChipButtonTwo;
